interface PersonAvatarStrokeProps {
  className?: string
}

export function PersonAvatarStroke({
  className = '',
}: PersonAvatarStrokeProps) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='102'
      height='101'
      viewBox='0 0 102 101'
      fill='none'
      className={className}
    >
      <path
        d='M42.1009 99.3764C33.8966 97.682 26.2683 93.895 19.9555 88.3824C13.6428 82.8698 8.85984 75.8187 6.07035 67.9128C3.28086 60.0068 2.57949 51.5142 4.03425 43.2583C5.48901 35.0024 9.05054 27.2634 14.3735 20.7916C19.6965 14.3197 26.6004 9.33464 34.4157 6.31961C42.2311 3.30459 50.6928 2.36192 58.9805 3.58302C67.2682 4.80411 75.1007 8.14754 81.7185 13.2891C88.3364 18.4307 93.5151 25.1961 96.7526 32.9292'
        stroke='currentColor'
        strokeWidth='5'
        strokeLinecap='round'
      />
    </svg>
  )
}
